import { Box, InputAdornment, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import { LockIcon } from '~/assets/icons'
import { TextInput, TextInputProps } from '~/components'
import { mutualTheme } from '~/utils/theme'
import { InputSubtitle } from '../InputSubtitle'
import { PasswordFormat } from './components'

export type PasswordInputProps = {
  disabled?: boolean,
  subtitle?: string,
  className?: string,
  removeIcon?: boolean,
  isVisible?: boolean,
  outsideLabel?: boolean,
  endAdornment?: React.ReactNode
}

const useStyles = makeStyles({
  label: {
    marginBottom: mutualTheme.spacing(0.5),
    color: mutualTheme.palette.textGray1.main
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  subTitle: {
    marginTop: mutualTheme.spacing(1)
  }
})

export const PasswordInput = React.forwardRef<HTMLDivElement, TextInputProps & PasswordInputProps>((props, ref) => {
  const {
    className, removeIcon, errorMessage,
    outsideLabel, containerClassName, subtitle, isVisible,
    label, endAdornment, InputProps, ...rest
  } = props
  const classes = useStyles()

  return (
    <Box className={clsx([classes.container, containerClassName])}>
      {outsideLabel && <Typography variant='body2' className={classes.label}>{label}</Typography>}
      <TextInput
        {...rest}
        label={!outsideLabel && label}
        variant='outlined'
        fullWidth
        ref={ref}
        className={className}
        type={isVisible ? 'text' : 'password'}
        errorMessage={errorMessage}
        InputProps={{
          ...InputProps,
          inputComponent: PasswordFormat as any,
          endAdornment: endAdornment || !removeIcon && <InputAdornment position='end'><LockIcon htmlColor={mutualTheme.palette.textGray4.main} /></InputAdornment>
        }}
      />
      {subtitle && <InputSubtitle className={classes.subTitle} text={subtitle} />}
    </Box>
  )
})
